import { classNames } from '@common/application/utils/classnames';
import { createPath } from '@common/application/utils/create-path';
import { RightArrowLine } from '@common/components/icon/right-arrow-line';
import { ROUTE_MAP } from '@common/constants/route-map';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

export const Breadcrumbs: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={classNames('container h-11', 'pc:h-13.5')}>
      <div className="flex items-center w-full h-full text-sm ">
        <Link className="text-black-3" href={createPath(ROUTE_MAP.HOME)}>
          {t('common:home')}
        </Link>
        <RightArrowLine className="mx-1 w-3 h-3 text-black-3" />
        <span className="text-black-1">{t('common:productDiff')}</span>
      </div>
    </div>
  );
};
